// 쿠키 가져오기
export default function getCookie(name) {
  var nameOfCookie = name + '=';
  var endOfCookie = '';
  var x = 0;
  while (x <= document.cookie.length) {
    var y = (x + nameOfCookie.length);
    if (document.cookie.substring(x, y) === nameOfCookie) {
      endOfCookie = document.cookie.indexOf(';', y);
      if ((endOfCookie) === -1)
        {endOfCookie = document.cookie.length;}
      return unescape(document.cookie.substring(y, endOfCookie));
    }
    x = document.cookie.indexOf(' ', x) + 1;
    if (x === 0)
      {break;}
  }
  return '';
}
